import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';

import SaveButton from './SaveButton';
import BackButton from './BackButton';
import setFieldTouched from 'final-form-set-field-touched';
import * as offerActions from '../../../redux/newOffer';
import { enm } from '../../../services/api';
import {
  FieldWithError,
  RepeatAdapter,
  AgeLimitAdapter,
  RepeatGroupAdapter,
  GroupUpdater,
  SimpleFilledSelect,
  ConfigurableSelect,
  SimpleCheckboxes,
} from './FormAdapters';
import { DateAdapter } from './DateAdapter';
import GenderPicker from './GenderPicker';
import GroupGenderPicker from './GroupGenderPicker';
import { validate2 } from './validation';
import { ComplexLabel, FormLabel, FormLabelBox, CategoryName } from '../../Common';
import { Row } from '../../Grid';
import '../../Form.css';

function isEmpty(obj: object) {
  for (var prop in obj) {
    return false;
  }
  return true;
}

const RepeatContainer = styled(Row)`
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: 0.6px;
  font-family: 'BrandonGrotesque-Regular';
  color: #555555;
  margin-top: 5px;
`;

const clearField = ([name], state, { changeValue }) => {
  changeValue(state, name, () => undefined);
};

const calculateSpot = ([name, value], state, { changeValue }) => {
  changeValue(state, name, () => (isNaN(value) ? 'x' : value));
};

const updateGroup = ([value], state, { changeValue }) => {
  changeValue(state, 'female_spots', (prev) =>
    prev ? (isNaN(value) || value === 0 ? 'x' : value) : prev
  );
  changeValue(state, 'male_spots', (prev) =>
    prev ? (isNaN(value) || value === 0 ? 'x' : value) : prev
  );
  changeValue(state, 'shared_spots', (prev) =>
    prev ? (isNaN(value) || value === 0 ? 'x' : value) : prev
  );
};

interface Props {
  business: any;
  offer: CreateOffer;
  addOfferDetails: Function;
  moveBack: Function;
}

function OfferForm2(props: Props) {
  const [options, setOptions] = useState<any>();
  const [gender, setGender] = useState<string>();

  const show_times = ['swing_by', 'timed'].includes(props.offer.type);

  const updateReservationField = ([name], state, { changeValue }) => {
    const values = {
      phone: props.business.phone_number,
      website: props.business.website,
      email: props.business.email,
    };

    changeValue(state, 'reservation_data', (x) => values[name]);
  };

  const onGenderChanged = (_gender) => {
    if (['m', 'f'].indexOf(_gender[0]) !== -1) {
      props.offer.sex = _gender[0];

      setGender(_gender);
    }
  };

  useEffect(() => {
    if (props.offer.type === 'job') {
      props.offer.shared_spots = '';

      Promise.all([
        enm.getShoeSizes(),
        enm.getDressSizes(),
        enm.getWaistSizes(),
        enm.getSuitSizes(),
        enm.getStatOptions(),
      ]).then((values) => {
        const options = {
          ...{ shoe: Object.values(Object.assign({}, values[0])['data']) },
          ...{ dress: Object.values(Object.assign({}, values[1])['data']) },
          ...{ waist: Object.values(Object.assign({}, values[2])['data']) },
          ...{ suit: Object.values(Object.assign({}, values[3])['data']) },
          ...Object.assign({}, Object.assign({}, values[4])['data']),
        };

        setOptions(options);
      });
    }
  }, []);

  return (
    <div>
      <Form
        onSubmit={(state) => props.addOfferDetails(state, +1)}
        initialValues={props.offer}
        validate={validate2}
        mutators={{
          clearField,
          updateReservationField,
          calculateSpot,
          updateGroup,
          setFieldTouched,
        }}
        render={({ handleSubmit, invalid, values, form }) => (
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <ComplexLabel first="MAXIMUM NUMBER OF CLAIMS" second="(HOW MANY MODELS?)" />
                <br />
                <div className="flex">
                  {values.is_group ? (
                    <GroupGenderPicker values={values} form={form} />
                  ) : (
                    <GenderPicker
                      onChanged={onGenderChanged}
                      strict={true}
                      allowEither={props.offer.type !== 'job'}
                      values={values}
                      form={form}
                    />
                  )}
                </div>

                {props.offer.type !== 'job' ? (
                  <div>
                    <br />
                    <ComplexLabel
                      first="AGE LIMIT"
                      second="(NEON COAT MEMBERS ARE ALL 18+)"
                      optional
                    />
                    <br />
                    <FieldWithError name="age_limit" component={AgeLimitAdapter} />
                    <ComplexLabel first="REPEAT" second="(HOW OFTEN YOUR OFFER IS AVAILABLE)" />
                    <RepeatContainer>
                      If you’d like your offer to repeat only on certain days of the week, please
                      choose the Custom option. A Neon Coat representative will be in touch to set
                      up a customized schedule.
                    </RepeatContainer>
                    <div className="row" style={{ paddingLeft: '15px', paddingTop: '30px' }}>
                      <RepeatGroupAdapter mutators={form.mutators} />
                    </div>
                    <br />
                    <div className="form-label-offer-box">
                      <ComplexLabel first="OFFER CONTACT" second="(FOR DISPLAY ON MODEL TICKET)" />
                    </div>
                  </div>
                ) : (
                  <div>
                    {options !== undefined ? (
                      <>
                        <div className="row">
                          <div className="col">
                            <FormLabelBox>
                              <FormLabel>HEIGHT MINIMUM</FormLabel>
                              <Field
                                name="height_minimum"
                                values={values}
                                boundconfiguration={options['height']}
                                render={(props) => <ConfigurableSelect {...props} />}
                              />
                            </FormLabelBox>

                            <FormLabelBox>
                              <FormLabel>WAIST SIZE MINIMUM</FormLabel>
                              <Field
                                name="waist_size_minimum_id"
                                items={options['waist']}
                                title="title"
                                render={(props) => <SimpleFilledSelect {...props} />}
                              />
                            </FormLabelBox>
                          </div>
                          <div className="col">
                            <FormLabelBox>
                              <FormLabel>HEIGHT MAXIMUM</FormLabel>
                              <Field
                                name="height_maximum"
                                boundconfiguration={options['height']}
                                render={(props) => <ConfigurableSelect {...props} />}
                              />
                            </FormLabelBox>

                            <FormLabelBox>
                              <FormLabel>WAIST SIZE MAXIMUM</FormLabel>
                              <Field
                                name="waist_size_maximum_id"
                                items={options['waist']}
                                title="title"
                                render={(props) => <SimpleFilledSelect {...props} />}
                              />
                            </FormLabelBox>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <FormLabelBox>
                              <FormLabel>HAIR COLOR</FormLabel>
                              <Field
                                name="hair_colors"
                                items={options['hair_colors']}
                                render={(props) => <SimpleCheckboxes {...props} />}
                              />
                            </FormLabelBox>

                            <FormLabelBox>
                              <FormLabel>EYE COLOR</FormLabel>
                              <Field
                                name="eye_colors"
                                size={3}
                                items={options['eye_colors']}
                                render={(props) => <SimpleCheckboxes {...props} />}
                              />
                            </FormLabelBox>

                            <FormLabelBox>
                              <FormLabel>BACKGROUND</FormLabel>
                              <Field
                                name="backgrounds"
                                items={options['backgrounds']}
                                render={(props) => <SimpleCheckboxes {...props} />}
                              />
                            </FormLabelBox>
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                )}
              </div>

              <div className="col-md-5">
                {props.offer.type === 'reservation_required' ? (
                  <div>
                    <ComplexLabel
                      first="RESERVATION RESCTRICTIONS"
                      second="(WHEN DO YOU PREFER MODELS MAKE RESERVATIONS?)"
                      row={true}
                      optional
                    />
                    <FieldWithError
                      name="reservation_restrictions"
                      component="input"
                      placeholder="e.g. M, W, F. 3-5pm"
                    />
                    <br />
                    <br />
                    <ComplexLabel first="RESERVATION METHOD" second="" />
                    <div
                      className="row"
                      style={{
                        paddingLeft: '15px',
                        paddingTop: '10px',
                        width: '90%',
                      }}
                    >
                      {['phone', 'email', 'website'].map((item) => (
                        <div className="col">
                          <div className="row">
                            <div>
                              <FieldWithError
                                name="reservation_method"
                                component={RepeatAdapter}
                                mutators={form.mutators}
                                title={item}
                              />
                            </div>
                            <CategoryName>{item.capitalize()}</CategoryName>
                          </div>
                        </div>
                      ))}
                    </div>
                    <br />
                    <ComplexLabel
                      first="RESERVATION METHOD DETAIL"
                      second="(PHONE, EMAIL OR WEBSITE)"
                      row={true}
                    />
                    <br />
                    <FieldWithError
                      name="reservation_data"
                      component="input"
                      placeholder="e.g. 917-227-3475"
                    />
                    <br />
                    <br />
                    <br />
                  </div>
                ) : null}

                {show_times ? (
                  <div>
                    <ComplexLabel first="START DATE/TIME" second="(WHEN SHOULD MODELS ARRIVE?)" />
                    <FieldWithError name="starts_at" component={DateAdapter} />
                    <br />
                    <br />
                    <ComplexLabel first="END DATE/TIME" second="(WHEN SHOULD MODELS LEAVE?)" />
                    <FieldWithError name="ends_at" component={DateAdapter} />
                    <br />
                    <br />
                  </div>
                ) : null}

                {values.is_group ? (
                  <div>
                    <ComplexLabel first="MINIMUM GROUP SIZE" second="" />
                    <br />
                    <FieldWithError name="group_min_size" component="input" />
                    <br />
                    <br />
                    <ComplexLabel first="MAXIMUM GROUP SIZE" second="" />
                    <br />
                    <FieldWithError
                      name="group_max_size"
                      mutator={form.mutators.updateGroup}
                      values={values}
                      component={GroupUpdater}
                    />
                    <br />
                    <br />
                    <ComplexLabel first="MAXIMUM NUMBER OF GROUPS" second="" />
                    <br />
                    <FieldWithError
                      name="group_max_number"
                      mutator={form.mutators.updateGroup}
                      values={values}
                      component={GroupUpdater}
                    />
                  </div>
                ) : null}

                {values.is_group && show_times ? (
                  <div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                  </div>
                ) : null}

                {props.offer.type === 'job' && options !== undefined ? (
                  <div className="row" style={{ marginTop: '138px' }}>
                    {gender === 'male' ? (
                      <>
                        <div className="col">
                          <FormLabelBox>
                            <FormLabel>COLLAR SIZE MINIMUM</FormLabel>
                            <Field
                              key="collar_size_minimum"
                              name="collar_size_minimum"
                              boundconfiguration={options['collar']}
                              boundonlyinches={true}
                              render={(props) => <ConfigurableSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>SLEEVE SIZE MINIMUM</FormLabel>
                            <Field
                              key="sleeve_size_minimum"
                              name="sleeve_size_minimum"
                              boundconfiguration={options['sleeve']}
                              boundonlyinches={true}
                              render={(props) => <ConfigurableSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>SUIT SIZE MINIMUM</FormLabel>
                            <Field
                              key="suit_size_minimum_id"
                              name="suit_size_minimum_id"
                              items={options['suit']}
                              title="title"
                              render={(props) => <SimpleFilledSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>INSEAM SIZE MINIMUM</FormLabel>
                            <Field
                              key="inseam_size_minimum"
                              name="inseam_size_minimum"
                              boundconfiguration={options['inseam']}
                              boundonlyinches={true}
                              render={(props) => <ConfigurableSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>SHOE SIZE MINIMUM</FormLabel>
                            <Field
                              key="shoe_size_minimum_id_male"
                              name="shoe_size_minimum_id_male"
                              items={options['shoe'].filter((item) => item.gender === 'male')}
                              render={(props) => <SimpleFilledSelect {...props} />}
                            />
                          </FormLabelBox>
                        </div>

                        <div className="col">
                          <FormLabelBox>
                            <FormLabel>COLLAR SIZE MAXIMUM</FormLabel>
                            <Field
                              key="collar_size_maximum"
                              name="collar_size_maximum"
                              boundconfiguration={options['collar']}
                              boundonlyinches={true}
                              render={(props) => <ConfigurableSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>SLEEVE SIZE MAXIMUM</FormLabel>
                            <Field
                              key="sleeve_size_maximum"
                              name="sleeve_size_maximum"
                              boundconfiguration={options['sleeve']}
                              boundonlyinches={true}
                              render={(props) => <ConfigurableSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>SUIT SIZE MAXIMUM</FormLabel>
                            <Field
                              key="suit_size_maximum_id"
                              name="suit_size_maximum_id"
                              items={options['suit']}
                              title="title"
                              render={(props) => <SimpleFilledSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>INSEAM SIZE MAXIMUM</FormLabel>
                            <Field
                              key="inseam_size_maximum"
                              name="inseam_size_maximum"
                              boundconfiguration={options['inseam']}
                              boundonlyinches={true}
                              render={(props) => <ConfigurableSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>SHOE SIZE MAXIMUM</FormLabel>
                            <Field
                              key="shoe_size_maximum_id_male"
                              name="shoe_size_maximum_id_male"
                              items={options['shoe'].filter((item) => item.gender === 'male')}
                              render={(props) => <SimpleFilledSelect {...props} />}
                            />
                          </FormLabelBox>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col">
                          <FormLabelBox>
                            <FormLabel>BUST SIZE MINIMUM</FormLabel>
                            <Field
                              key="bust_size_minimum"
                              name="bust_size_minimum"
                              boundconfiguration={options['bust']}
                              boundonlyinches={true}
                              render={(props) => <ConfigurableSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>HIPS SIZE MINIMUM</FormLabel>
                            <Field
                              key="hips_size_minimum"
                              name="hips_size_minimum"
                              boundconfiguration={options['hips']}
                              boundonlyinches={true}
                              render={(props) => <ConfigurableSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>DRESS SIZE MINIMUM</FormLabel>
                            <Field
                              key="dress_size_minimum_id"
                              name="dress_size_minimum_id"
                              items={options['dress']}
                              render={(props) => <SimpleFilledSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>SHOE SIZE MINIMUM</FormLabel>
                            <Field
                              key="shoe_size_minimum_id_female"
                              name="shoe_size_minimum_id_female"
                              items={options['shoe'].filter((item) => item.gender === 'female')}
                              render={(props) => <SimpleFilledSelect {...props} />}
                            />
                          </FormLabelBox>
                        </div>
                        <div className="col">
                          <FormLabelBox>
                            <FormLabel>BUST SIZE MAXIMUM</FormLabel>
                            <Field
                              key="bust_size_maximum"
                              name="bust_size_maximum"
                              boundconfiguration={options['bust']}
                              boundonlyinches={true}
                              render={(props) => <ConfigurableSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>HIPS SIZE MAXIMUM</FormLabel>
                            <Field
                              key="hips_size_maximum"
                              name="hips_size_maximum"
                              boundconfiguration={options['hips']}
                              boundonlyinches={true}
                              render={(props) => <ConfigurableSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>DRESS SIZE MAXIMUM</FormLabel>
                            <Field
                              key="dress_size_maximum_id"
                              name="dress_size_maximum_id"
                              items={options['dress']}
                              render={(props) => <SimpleFilledSelect {...props} />}
                            />
                          </FormLabelBox>

                          <FormLabelBox>
                            <FormLabel>SHOE SIZE MAXIMUM</FormLabel>
                            <Field
                              key="shoe_size_maximum_id_female"
                              name="shoe_size_maximum_id_female"
                              items={options['shoe'].filter((item) => item.gender === 'female')}
                              render={(props) => <SimpleFilledSelect {...props} />}
                            />
                          </FormLabelBox>
                        </div>
                      </>
                    )}
                  </div>
                ) : null}

                <div style={{ height: '50px', width: '1px' }} />

                <BackButton
                  click={(values: CreateOffer) => {
                    props.moveBack();
                  }}
                />
                <SaveButton
                  click={handleSubmit}
                  ready={!invalid && isEmpty(validate2(values))}
                  style={{ left: '100px' }}
                  middle={true}
                />
              </div>
            </div>
          </form>
        )}
      />
    </div>
  );
}

export default connect(
  ({ business, newOffer }: any) => ({ offer: newOffer, business }),
  offerActions
)(OfferForm2);
